import { WINDOW } from "../utils/window-utils"
import { getSingletonInstance } from "../services/singleton-cache"

export default function QuerySelector(selector: string): Function {
    return (target: any, propertyKey: string) => {
        const singletonTarget: any = getSingletonInstance(target)
        singletonTarget[propertyKey] = WINDOW.nativeWindow.document.querySelector(selector)
    }
}